/* eslint-disable no-nested-ternary */
import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Checkbox, Select, Tooltip } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import UserActions from '@Actions/userActions';
import generalConfigurationActions from '../../../../actions/configurations/generalConfigurationActions';
import { configMapping } from '../../../../apis/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

const GeneralConfiguration = ({
  entityType, getGeneralConfiguration, generalConfigurationProducts, generalConfigurationAnnualMaintenanceContract, getGeneralConfigurationAnnualMaintenanceContractLoading, generalConfigurationAPInvoice, generalConfigurationAPInvoiceLoading,
  generalConfigurationVendors, generalConfigurationGoodReceivingNotes, generalConfigurationPurchaseOrders,
  generalConfigurationPurchaseRequest, generalConfigurationDebitNote, generalConfigurationCreditNote, generalConfigurationInvoice, generalConfigurationManufacturingOrder,
  getGeneralConfigurationProductsLoading, getGeneralConfigurationVendorsLoading, getGeneralConfigurationGoodReceivingNotesLoading,
  getGeneralConfigurationPurchaseOrdersLoading, getGeneralConfigurationPurchaseRequestLoading, getGeneralConfigurationDebitNoteLoading, getGeneralConfigurationCreditNoteLoading,
  getGeneralConfigurationInvoiceLoading, getGeneralConfigurationManufacturingOrderLoading, updateGeneralConfiguration, updateGeneralConfigurationLoading, generalConfigurationSalesEstimate, generalConfigurationPackingSlip,
  getUserProfile, getGeneralConfigurationSalesOrderLoading, generalConfigurationSalesOrder, getGeneralConfigurationStockTransferLoading, generalConfigurationStockTransfer, getGeneralConfigurationSalesEstimateLoading, generalConfigurationPackingSlipLoading, user, generalConfigurationCustomers, generalConfigurationCustomersLoading, generalConfigurationReturnSlip, getGeneralConfigurationReturnSlipLoading,

}) => {
  const [configData, setConfigData] = useState([]);

  const [hoveredItemId, setHoveredItemId] = useState(null);

  // useEffect to get the general configuration data
  useEffect(() => {
    getGeneralConfiguration(entityType);
  }, [entityType]);

  // function to get loading state
  function getGeneralConfigurationLoading(entityTypes) {
    switch (entityTypes) {
      case 'PRODUCTS':
        return getGeneralConfigurationProductsLoading;
      case 'VENDORS':
        return getGeneralConfigurationVendorsLoading;
      case 'GOOD_RECEIVING_NOTE':
        return getGeneralConfigurationGoodReceivingNotesLoading;
      case 'PURCHASE_ORDER':
        return getGeneralConfigurationPurchaseOrdersLoading;
      case 'PURCHASE_REQUEST':
        return getGeneralConfigurationPurchaseRequestLoading;
      case 'DEBIT_NOTE':
        return getGeneralConfigurationDebitNoteLoading;
      case 'CREDIT_NOTE':
        return getGeneralConfigurationCreditNoteLoading;
      case 'RETURN_SLIP':
        return getGeneralConfigurationReturnSlipLoading;
      case 'INVOICE':
        return getGeneralConfigurationInvoiceLoading;
      case 'MANUFACTURING_ORDER':
        return getGeneralConfigurationManufacturingOrderLoading;
      case 'SALES_ESTIMATE':
        return getGeneralConfigurationSalesEstimateLoading;
      case 'SALES_ORDER':
        return getGeneralConfigurationSalesOrderLoading;
      case 'PACKING_SLIP':
        return generalConfigurationPackingSlipLoading;
      case 'STOCK_TRANSFER':
        return getGeneralConfigurationStockTransferLoading;
      case 'CUSTOMERS':
        return generalConfigurationCustomersLoading;
      case 'ANNUAL_MAINTENANCE_CONTRACT':
        return getGeneralConfigurationAnnualMaintenanceContractLoading;
      case 'ACCOUNT_PAYABLE_INVOICE':
        return generalConfigurationAPInvoiceLoading;
      default:
        return false;
    }
  }
  // function to get data Success
  function getGeneralConfigurationData(entityTypes) {
    switch (entityTypes) {
      case 'PRODUCTS':
        return generalConfigurationProducts;
      case 'VENDORS':
        return generalConfigurationVendors;
      case 'GOOD_RECEIVING_NOTE':
        return generalConfigurationGoodReceivingNotes;
      case 'PURCHASE_ORDER':
        return generalConfigurationPurchaseOrders;
      case 'PURCHASE_REQUEST':
        return generalConfigurationPurchaseRequest;
      case 'DEBIT_NOTE':
        return generalConfigurationDebitNote;
      case 'CREDIT_NOTE':
        return generalConfigurationCreditNote;
      case 'RETURN_SLIP':
        return generalConfigurationReturnSlip;
      case 'INVOICE':
        return generalConfigurationInvoice;
      case 'MANUFACTURING_ORDER':
        return generalConfigurationManufacturingOrder;
      case 'SALES_ESTIMATE':
        return generalConfigurationSalesEstimate;
      case 'SALES_ORDER':
        return generalConfigurationSalesOrder;
      case 'PACKING_SLIP':
        return generalConfigurationPackingSlip;
      case 'STOCK_TRANSFER':
        return generalConfigurationStockTransfer;
      case 'CUSTOMERS':
        return generalConfigurationCustomers;
      case 'ANNUAL_MAINTENANCE_CONTRACT':
        return generalConfigurationAnnualMaintenanceContract;
      case 'ACCOUNT_PAYABLE_INVOICE':
        return generalConfigurationAPInvoice;
      default:
        return false;
    }
  }
  // useEffect to set the configData from the response
  useEffect(() => {
    const data = getGeneralConfigurationData(entityType);
    if (data) {
      const booleanValues = {};
      const stringValues = {};
      const numberValues = {};
      const selectValue = {};
      // Separate the data into boolean, string and number values
      Object.entries(data).forEach(([name, value]) => {
        if (typeof value === 'boolean') {
          booleanValues[name] = value;
        } else if (name === 'default_costing_method') {
          selectValue[name] = value;
        } else if (typeof value === 'string') {
          stringValues[name] = value;
        } else if (typeof value === 'number') {
          numberValues[name] = value;
        }
      });
      // Create responseArray with the specified order
      const responseArray = [
        ...Object.entries(booleanValues).map(([name, value]) => ({ id: uuidv4(), name, value })),
        ...Object.entries(stringValues).map(([name, value]) => ({ id: uuidv4(), name, value })),
        ...Object.entries(numberValues).map(([name, value]) => ({ id: uuidv4(), name, value })),
        ...Object.entries(selectValue).map(([name, value]) => ({ id: uuidv4(), name, value })),
      ];
      setConfigData(responseArray);
    }
  }, [entityType, generalConfigurationProducts, generalConfigurationVendors, generalConfigurationGoodReceivingNotes, generalConfigurationPurchaseOrders, generalConfigurationAnnualMaintenanceContract, generalConfigurationAPInvoice,
    generalConfigurationPurchaseRequest, generalConfigurationDebitNote, generalConfigurationCreditNote, generalConfigurationInvoice, generalConfigurationManufacturingOrder, generalConfigurationSalesEstimate, generalConfigurationSalesOrder, generalConfigurationStockTransfer, generalConfigurationCustomers, generalConfigurationReturnSlip]);

  // function to handle checkbox change and update the configData
  const handleCheckboxChange = (id) => {
    const updatedConfigData = configData.map((item) => {
      if (item.id === id) {
        return { ...item, value: !item.value };
      }
      return item;
    });
    setConfigData(updatedConfigData);
  };
  // function to handle drop down change and update the configData
  const handleDropDownChange = (id, value) => {
    const updatedConfigData = configData.map((item) => (item.id === id ? { ...item, value } : item));
    setConfigData(updatedConfigData);
  };
  const handleNumericValueChange = (id, value) => {
    // Find the item in configData and update its value
    const updatedConfigData = configData.map((item) => (item.id === id ? { ...item, value: parseInt(value, 10) } : item));

    // Update the state with the new configData
    setConfigData(updatedConfigData);
  };

  const handleStringValueChange = (id, value) => {
    // Find the item in configData and update its value
    const updatedConfigData = configData.map((item) => (item.id === id ? { ...item, value } : item));

    // Update the state with the new configData
    setConfigData(updatedConfigData);
  };

  // function to handle update profile
  const handleUpdateProfile = () => {
    // function to convert array to object
    const newConfigData = configData.reduce((acc, item) => {
      acc[item.name] = item.value;
      return acc;
    }, {});

    const payload = {
      entity_name: entityType,
      data: newConfigData,
    };

    updateGeneralConfiguration(payload, () => {
      getGeneralConfiguration(entityType, () => {
        getUserProfile();
      });
    });
  };
  return (
    <Fragment>
      {getGeneralConfigurationLoading(entityType) ? (
        <Fragment>
          <div className="ant-row">
            <div className="ant-col-md-16">
              <div className=" general_config__loading__wrapper">
                {[1, 2, 3].map((item) => (
                  <div key={item} className=" general_config__loading__wrapper-row">
                    <div className="general_config__loading__wrapper-row__label loadingBlock" />
                    <div className=" general_config__loading__wrapper-row__value loadingBlock" />
                  </div>
                ))}

              </div>
            </div>
          </div>
        </Fragment>
      ) : (
        <React.Fragment>
          <div
            className="general-config__wrapper"
            style={{
              opacity: updateGeneralConfigurationLoading ? '0.5' : '1',
              pointerEvents: updateGeneralConfigurationLoading ? 'none' : 'auto',
            }}
          >
            {configData?.map((item) => (
              (item.name !== 'ui_name' && configMapping(user)?.hasOwnProperty(item.name))
              && (
                <div key={item.id} style={{ display: 'flex', alignItems: 'center' }}>
                  {typeof item.value === 'boolean' ? (
                    <React.Fragment>
                      <Checkbox
                        checked={item.value}
                        onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
                      >
                        <H3Text text={configMapping(user)[`${item.name}`]} className="general_checkbox-label" />
                        {/* <div
                        className="icon-description-container"
                        onMouseEnter={() => setHoveredItemId(item.id)}
                        onMouseLeave={() => setHoveredItemId(null)}
                      >
                        <FontAwesomeIcon icon={faInfoCircle} className="info-icon" />
                        {hoveredItemId === item.id && (
                          <div className="description">{item.description}</div>
                        )}
                      </div> */}
                      </Checkbox>
                    </React.Fragment>
                  ) : typeof item.value === 'number' ? (
                    <div
                      className="numeric-input"

                    >
                      <H3FormInput
                        name="a valid number"
                        type="number"
                        containerClassName="orgInputContainer"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(e) => handleNumericValueChange(item.id, e.target.value)}
                        value={item.value}
                        required
                        label={configMapping(user)[`${item.name}`]}
                      />
                    </div>
                  ) : item.name === 'default_costing_method' ? (
                    <div
                      className="numeric-input"
                    >
                      <div className="orgFormLabel">{configMapping(user)[`${item.name}`]}</div>
                      <PRZSelect
                        onChange={(value) => handleDropDownChange(item.id, value)}
                        value={item.value}
                        required
                        suffixIcon={null}
                        placeholder={`Select ${configMapping(user)[`${item.name}`]}`}
                      >
                        <Option value="cost_price">Cost Price</Option>
                        <Option value="FIFO">FIFO</Option>
                      </PRZSelect>
                    </div>
                  ) : item.name === 'gst_details_in_transaction' ? (
                    <div className="numeric-input">
                      <div className="orgFormLabel">{configMapping(user)[`${item.name}`]}</div>
                      <PRZSelect
                        onChange={(value) => handleDropDownChange(item.id, value)}
                        value={item.value}
                        required
                        suffixIcon={null}
                        placeholder={`Select ${configMapping(user)[`${item.name}`]}`}
                      >
                        <Option value="AS_PER_MASTER">As Per Master</Option>
                        <Option value="AS_PER_DOCUMENT">As Per Document</Option>
                      </PRZSelect>
                    </div>
                  ) : item.name === 'round_off_method' ? (
                    <div className="numeric-input">
                      <div className="orgFormLabel" style={{ display: 'flex', }}>
                        {configMapping(user)[`${item.name}`]}
                        &nbsp;&nbsp;
                        <Tooltip
                          title={(
                            <div className='round-off__wrapper'>
                              <div className='round-off__title'>
                                Examples
                              </div>
                              <div className='round-off__examples'>
                                <div className='round-off__example-header'>
                                  <div className='round-off__header-method'>
                                    METHOD
                                  </div>
                                  <div className='round-off__header-example'>
                                    BEFORE
                                  </div>
                                  <div className='round-off__header-example'>
                                    AFTER
                                  </div>
                                </div>
                                <div className='round-off__example-content'>
                                  <div className='round-off__example-label'>
                                    No Round Off
                                  </div>
                                  <div className='round-off__example'>
                                    3560.50
                                  </div>
                                  <div className='round-off__example'>
                                    3560.50
                                  </div>
                                </div>
                                <div className='round-off__example-content'>
                                  <div className='round-off__example-label'>
                                    Lower Round Off
                                  </div>
                                  <div className='round-off__example'>
                                    3560.50
                                  </div>
                                  <div className='round-off__example'>
                                    3560.00
                                  </div>
                                </div>
                                <div className='round-off__example-content'>
                                  <div className='round-off__example-label'>
                                    Upper Round Off
                                  </div>
                                  <div className='round-off__example'>
                                    3560.50
                                  </div>
                                  <div className='round-off__example'>
                                    3561.00
                                  </div>
                                </div>
                                <div className='round-off__example-content'>
                                  <div className='round-off__example-label'>
                                    Nearest Round Off
                                  </div>
                                  <div className='round-off__example'>
                                    3560.50
                                  </div>
                                  <div className='round-off__example'>
                                    3561.00
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          color='white'
                          overlayInnerStyle={{
                            border: '1px solid',
                            borderColor: '#2D7DF7',
                            borderRadius: '5px',
                            width: '300px',
                          }}
                          placement='right'
                        >
                          <div style={{ cursor: 'pointer', }}>
                            <FontAwesomeIcon icon={faCircleInfo} style={{ color: '#2D7DF7', }} />
                          </div>
                        </Tooltip>
                      </div>
                      <PRZSelect
                        onChange={(value) => handleDropDownChange(item.id, value)}
                        value={item.value}
                        required
                        suffixIcon={null}
                        placeholder={`Select ${configMapping(user)[`${item.name}`]}`}
                        style={{ minWidth: '150px', }}
                      >
                        <Option value={'NO_ROUND_OFF'}>No Round Off</Option>
                        <Option value={'LOWER_ROUND_OFF'}>Lower Round Off</Option>
                        <Option value={'UPPER_ROUND_OFF'}>Upper Round Off</Option>
                        <Option value={'NEAREST_WHOLE_NUMBER'}>Nearest Round Off</Option>
                      </PRZSelect>
                    </div>
                  ) : (
                    <div
                      className="string-input"
                    >
                      <H3FormInput
                        type="text"
                        containerClassName="orgInputContainer"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(e) => handleStringValueChange(item.id, e.target.value)}
                        value={item.value}
                        required
                        label={configMapping(user)[`${item.name}`]}
                      />
                    </div>
                  )}
                </div>
              )
            ))}
          </div>

          <div className="save_general_config ">
            <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text="Save"
                onClick={() => {
                  handleUpdateProfile();
                }}
                isLoading={updateGeneralConfigurationLoading || getGeneralConfigurationLoading(entityType)}
                disabled={updateGeneralConfigurationLoading || getGeneralConfigurationLoading(entityType)}
                style={{
                  width: '100px',
                  borderRadius: '5px',
                  padding: '7px 0px',
                  marginLeft: '0',
                  marginTop: '20px',
                }}
              />
            </div>
          </div>
        </React.Fragment>
      )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, GeneralConfigurationReducers }) => ({
  user: UserReducers.user,
  generalConfigurationProducts: GeneralConfigurationReducers.generalConfigurationProducts,
  generalConfigurationVendors: GeneralConfigurationReducers.generalConfigurationVendors,
  generalConfigurationCustomers: GeneralConfigurationReducers.generalConfigurationCustomers,
  generalConfigurationGoodReceivingNotes: GeneralConfigurationReducers.generalConfigurationGoodReceivingNotes,
  generalConfigurationPurchaseOrders: GeneralConfigurationReducers.generalConfigurationPurchaseOrders,
  generalConfigurationPurchaseRequest: GeneralConfigurationReducers.generalConfigurationPurchaseRequest,
  generalConfigurationDebitNote: GeneralConfigurationReducers.generalConfigurationDebitNote,
  generalConfigurationCreditNote: GeneralConfigurationReducers.generalConfigurationCreditNote,
  generalConfigurationReturnSlip: GeneralConfigurationReducers.generalConfigurationReturnSlip,
  generalConfigurationInvoice: GeneralConfigurationReducers.generalConfigurationInvoice,
  generalConfigurationManufacturingOrder: GeneralConfigurationReducers.generalConfigurationManufacturingOrder,
  getGeneralConfigurationProductsLoading: GeneralConfigurationReducers.getGeneralConfigurationProductsLoading,
  getGeneralConfigurationVendorsLoading: GeneralConfigurationReducers.getGeneralConfigurationVendorsLoading,
  getGeneralConfigurationCustomersLoading: GeneralConfigurationReducers.getGeneralConfigurationCustomersLoading,
  getGeneralConfigurationGoodReceivingNotesLoading: GeneralConfigurationReducers.getGeneralConfigurationGoodReceivingNotesLoading,
  getGeneralConfigurationPurchaseOrdersLoading: GeneralConfigurationReducers.getGeneralConfigurationPurchaseOrdersLoading,
  getGeneralConfigurationPurchaseRequestLoading: GeneralConfigurationReducers.getGeneralConfigurationPurchaseRequestLoading,
  getGeneralConfigurationDebitNoteLoading: GeneralConfigurationReducers.getGeneralConfigurationDebitNoteLoading,
  getGeneralConfigurationCreditNoteLoading: GeneralConfigurationReducers.getGeneralConfigurationCreditNoteLoading,
  getGeneralConfigurationReturnSlipLoading: GeneralConfigurationReducers.getGeneralConfigurationReturnSlipLoading,
  getGeneralConfigurationInvoiceLoading: GeneralConfigurationReducers.getGeneralConfigurationInvoiceLoading,
  getGeneralConfigurationManufacturingOrderLoading: GeneralConfigurationReducers.getGeneralConfigurationManufacturingOrderLoading,
  updateGeneralConfigurationLoading: GeneralConfigurationReducers.updateGeneralConfigurationLoading,
  generalConfigurationSalesOrder: GeneralConfigurationReducers.generalConfigurationSalesOrder,
  getGeneralConfigurationSalesOrderLoading: GeneralConfigurationReducers.getGeneralConfigurationSalesOrderLoading,
  getGeneralConfigurationStockTransferLoading: GeneralConfigurationReducers.getGeneralConfigurationStockTransferLoading,
  generalConfigurationStockTransfer: GeneralConfigurationReducers.generalConfigurationStockTransfer,
  generalConfigurationSalesEstimate: GeneralConfigurationReducers.generalConfigurationSalesEstimate,
  getGeneralConfigurationSalesEstimateLoading: GeneralConfigurationReducers.getGeneralConfigurationSalesEstimateLoading,
  generalConfigurationPackingSlip: GeneralConfigurationReducers.generalConfigurationPackingSlip,
  generalConfigurationPackingSlipLoading: GeneralConfigurationReducers.generalConfigurationPackingSlipLoading,
  generalConfigurationAnnualMaintenanceContract: GeneralConfigurationReducers.generalConfigurationAnnualMaintenanceContract,
  generalConfigurationAPInvoice: GeneralConfigurationReducers.generalConfigurationAPInvoice,
  getGeneralConfigurationAnnualMaintenanceContractLoading: GeneralConfigurationReducers.getGeneralConfigurationAnnualMaintenanceContractLoading,
  generalConfigurationAPInvoiceLoading: GeneralConfigurationReducers.generalConfigurationAPInvoiceLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getGeneralConfiguration: (entityType, callback) => dispatch(generalConfigurationActions.getGeneralConfiguration(entityType, callback)),
  updateGeneralConfiguration: (payload, callback) => dispatch(generalConfigurationActions.updateGeneralConfiguration(payload, callback)),
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GeneralConfiguration));
